const points = point => ({
  name: `Time: ${point.Z}`,
  x: point.X,
  y: point.Y,
});

const series = data => ({
  dashStyle: 'Solid',
  data: data.Points.map(points),
  lineWidth: 1,
  name: data.Column,
});

const charts = chart => ({
  title: chart.Table,
  series: chart.Series.map(series),
});

export default response => response.map(charts);
